package com.yendo.mx.utils

import androidx.compose.runtime.Composable
import coil3.ImageLoader
import coil3.annotation.ExperimentalCoilApi
import coil3.compose.setSingletonImageLoaderFactory
import coil3.request.CachePolicy

@OptIn(ExperimentalCoilApi::class)
@Composable
fun ConfigurarCoilGlobal(content: @Composable () -> Unit) {
    setSingletonImageLoaderFactory { context ->
        ImageLoader.Builder(context)
            .memoryCachePolicy(CachePolicy.ENABLED)
            .diskCachePolicy(if (esAndroid()) CachePolicy.ENABLED else CachePolicy.DISABLED)
            .build()
    }
    content()
}
